const cell = value => {
  const raw = String(value ?? '');
  return '"' + (/^[=+@-]/.test(raw) ? "'" + raw : raw).replaceAll('"', '""') + '"';
};
export function clientCsv(client, calculators) {
  const rows = [['Section', 'Field', 'Value']];
  function flatten(section, key, value) {
    if (value !== null && typeof value === 'object') {
      for (const [child, item] of Object.entries(value)) flatten(section, key ? `${key}.${child}` : child, item);
    } else rows.push([section, key, value]);
  }
  flatten('Client profile', '', client.profile);
  flatten('Client record', '', { clientId: client.id, ownerEmail: client.ownerEmail, adviserEmail: client.adviserEmail, lastSaved: client.updatedAt });
  for (const [id, draft] of Object.entries(calculators || {})) flatten(id, '', draft);
  return '\uFEFF' + rows.map(row => row.map(cell).join(',')).join('\r\n');
}
export function downloadClientCsv(client, calculators) {
  const url = URL.createObjectURL(new Blob([clientCsv(client, calculators)], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  const name = client.profile.name.replace(/[^a-z0-9_-]+/gi, '-').slice(0, 80) || 'client';
  link.href = url; link.download = `${name}-pension-calculators.csv`;
  document.body.appendChild(link); link.click(); link.remove(); URL.revokeObjectURL(url);
}
